"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useSiteTracking;
exports.SiteTrackingContext = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SiteTrackingContext = /*#__PURE__*/(0, _react.createContext)();
exports.SiteTrackingContext = SiteTrackingContext;

function useSiteTracking(trackingConfig) {
  var trackingConfigRef = (0, _react.useRef)(trackingConfig);
  var pageDataRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    trackingConfigRef.current = trackingConfig;
  });
  var providerValue = (0, _react.useMemo)(function () {
    return {
      getSiteData: function getSiteData() {
        return trackingConfigRef.current.siteData;
      },
      getPageTracking: function getPageTracking() {
        return trackingConfigRef.current.pageTracking;
      },
      getEventTracking: function getEventTracking() {
        return trackingConfigRef.current.eventTracking;
      },
      setPageData: function setPageData(pageData) {
        pageDataRef.current = pageData;
      },
      getPageData: function getPageData() {
        return pageDataRef.current;
      }
    };
  }, []);
  var SiteTracking = (0, _react.useCallback)(function (_ref) {
    var children = _ref.children;
    return /*#__PURE__*/_react["default"].createElement(SiteTrackingContext.Provider, {
      value: providerValue
    }, children);
  }, [providerValue]);
  return {
    SiteTracking: SiteTracking
  };
}